module.exports = __webpack_public_path__ + "img/tarj1-4.e0df27a1.png";